import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=0d6a5f17"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=0d6a5f17&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d6a5f17')) {
      api.createRecord('0d6a5f17', component.options)
    } else {
      api.reload('0d6a5f17', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=0d6a5f17", function () {
      api.rerender('0d6a5f17', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/businessflowWitness/detail.vue"
export default component.exports